import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import './TasksReport.scss';
import TaskResponseForm from '../tasks-training/TaskResponseForm';
import taskResponsesActionCreators from '../../store/tasks/action-creators/task-responses';
import TaskGroups from './TaskGroups';

class TasksReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editGroup: null,
    };
  }

  componentDidMount() {}

  // ----------------
  // Methods
  // ----------------

  createTaskResponse(name, response, { guid: taskGuid }) {
    const taskResponse = {
      oitGuid: this.props.oitGuid,
      response: name,
      responseDate: new Date(),
      signedAt: null,
      taskGuid,
    };

    this.props.createTaskResponse(taskResponse);
  }

  editTaskResponse(
    {
      guid,
      task: { taskGuid },
    },
    name,
    response,
  ) {
    this.props.updateTaskResponse(taskGuid, guid, name);
  }

  handleCheck(name, response, task) {
    if (this.props.taskResponsesMap[task.guid]) {
      this.editTaskResponse(
        this.props.taskResponsesMap[task.guid],
        name,
        response,
      );
    } else {
      this.createTaskResponse(name, response, task);
    }
  }

  setTaskGroupEdit(taskGroup) {
    this.setState({
      editGroup: taskGroup,
    });
  }

  finishEditGroup() {
    this.setState({
      editGroup: null,
    });
  }

  acknowledgeTaskGroup() {
    const taskResponses = this.getTasksResponsesForGroup(
      this.props.tasks,
      this.state.editGroup,
    );
    this.props.acknowledgeTasksResponses(taskResponses);
  }

  signTaskGroup() {
    const taskResponses = this.getTasksResponsesForGroup(
      this.props.tasks,
      this.state.editGroup,
    );
    this.props.signTaskGroup(taskResponses);
  }

  getTasksResponsesForGroup(tasks, group) {
    const tasksForGroup = this.getTasksForGroup(tasks, group);
    const taskResponses = tasksForGroup.map((task) => {
      return this.props.taskResponsesMap[task.guid];
    });

    return taskResponses;
  }

  getTasksForGroup(tasks, group) {
    return (
      tasks &&
      tasks.filter(({ taskGroup: { taskGroupGuid } }) =>
        group && taskGroupGuid === group.guid)
    );
  }

  getGroupStatus(group) {
    const groupTasks = this.getTasksForGroup(this.props.tasks, group);

    let isNotFiled = false;
    let isNotAcknowledged = false;
    let isNotSigned = false;

    groupTasks.forEach((task) => {
      if (!this.props.taskResponsesMap[task.guid]) {
        isNotFiled = true;
        isNotAcknowledged = true;
      }
      if (
        this.props.taskResponsesMap[task.guid] &&
        !this.props.taskResponsesMap[task.guid].acknowledgedAt
      ) {
        isNotAcknowledged = true;
      }

      if (
        this.props.taskResponsesMap[task.guid] &&
        !this.props.taskResponsesMap[task.guid].signedAt
      ) {
        isNotSigned = true;
      }
    });

    const completed = !isNotAcknowledged && !isNotSigned;

    if (completed) {
      return 'completed';
    } else if (isNotFiled) {
      return 'pending';
    }
    if (isNotSigned) {
      return 'pending-signature';
    }
    return 'pending-acknowledgement';
  }

  // ----------------
  // getters
  // ----------------

  get currentTasks() {
    return this.getTasksForGroup(this.props.tasks, this.state.editGroup);
  }

  get canEdit() {
    return (
      this.props.userContext.hasScope('fto') ||
      this.props.userContext.hasScope('ftoc') ||
      this.props.userContext.hasScope('sup')
    );
  }

  get canAcknowledge() {
    return this.props.userContext.hasScope('oit');
  }

  get isTaskResponseCompleted() {
    return (
      this.getGroupStatus(this.state.editGroup) !== 'pending' &&
      this.getGroupStatus(this.state.editGroup) !== 'pending-signature'
    );
  }

  render() {
    return (
      <div className="tasks-report modal-body">
        {!this.state.editGroup ? (
          <TaskGroups
            tasks={this.props.tasks}
            phase={this.props.phase}
            taskResponsesMap={this.props.taskResponsesMap}
            canEdit={this.canEdit}
            canAcknowledge={this.canAcknowledge}
            getGroupStatus={this.getGroupStatus.bind(this)}
            onGroupEdit={taskGroup => this.setTaskGroupEdit(taskGroup)}
          />
        ) : (
          <Fragment>
            <div className="task-category">
              <div>{this.state.editGroup.name}</div>
              <button
                className="button small"
                onClick={() => this.finishEditGroup()}
              >
                <i className="fa fa-chevron-left" />
                <span>Back</span>
              </button>
            </div>
            <div className="task-category-details">
              {this.state.editGroup.description}
            </div>
            {this.currentTasks &&
              this.currentTasks.map(task => (
                <TaskResponseForm
                  key={task.guid}
                  task={task}
                  disabled={!this.canEdit}
                  completed={this.isTaskResponseCompleted}
                  taskResponse={this.props.taskResponsesMap[task.guid]}
                  onCheck={(name, response) =>
                    this.handleCheck(name, response, task)
                  }
                />
              ))}
            {this.canEdit &&
              this.getGroupStatus(this.state.editGroup) === 'pending' && (
                <div className="text-right">
                  <button
                    className="button primary small"
                    onClick={() => this.finishEditGroup()}
                  >
                    <span>Submit</span>
                  </button>
                </div>
              )}
            {!this.canEdit &&
              !this.canAcknowledge &&
              this.getGroupStatus(this.state.editGroup) !==
                'pending-acknowledgement' && (
                <div className="text-right">
                  <button
                    className="button small"
                    onClick={() => this.finishEditGroup()}
                  >
                    <i className="fa fa-chevron-left" />
                    <span>Back</span>
                  </button>
                </div>
              )}
            {this.canEdit &&
              this.getGroupStatus(this.state.editGroup) ===
                'pending-signature' && (
                <div className="acknowledge-task">
                  <p>
                    I certify that i have received sufficient training and have
                    basic understanding og this task area
                  </p>
                  <button
                    className="button primary small"
                    onClick={() => this.signTaskGroup()}
                  >
                    <i className="fa fa-check" />
                    <span>Sign and Date</span>
                  </button>
                </div>
              )}

            {this.canAcknowledge &&
              this.getGroupStatus(this.state.editGroup) ===
                'pending-acknowledgement' && (
                <div className="acknowledge-task">
                  <p>
                    I certify that i have received sufficient training and have
                    basic understanding og this task area
                  </p>
                  <button
                    className="button primary small"
                    onClick={() => this.acknowledgeTaskGroup()}
                  >
                    <i className="fa fa-check" />
                    <span>I agree</span>
                  </button>
                </div>
              )}

            {(this.getGroupStatus(this.state.editGroup) ===
              'pending-acknowledgement' ||
              this.getGroupStatus(this.state.editGroup) === 'completed') && (
              <div className="text-right signed-acknowleadged">
                <div className="signed">
                  <i className="fa fa-check" />
                  <span>Signed</span>
                </div>

                {this.getGroupStatus(this.state.editGroup) === 'completed' && (
                  <div className="acknowledged">
                    <i className="fa fa-thumbs-o-up" />
                    <span>Acknowledged</span>
                  </div>
                )}
              </div>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tasks: state.tasks.tasks,
    // taskResponses: state.tasks.taskResponses,
    taskResponsesMap: state.tasks.taskResponsesMap,
    userContext: state.common.userContext,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    createTaskResponse: (taskResponse) => {
      return dispatch(taskResponsesActionCreators.createTaskResponse(taskResponse));
    },
    updateTaskResponse: (taskGuid, taskResponseGuid, response) => {
      return dispatch(taskResponsesActionCreators.updateTaskResponse(
        taskGuid,
        taskResponseGuid,
        response,
      ));
    },
    acknowledgeTasksResponses: (taskResponses) => {
      return dispatch(taskResponsesActionCreators.acknowledgeTasksResponses(taskResponses));
    },
    signTaskGroup: (taskResponses) => {
      return dispatch(taskResponsesActionCreators.signTaskGroup(taskResponses));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TasksReport);
